import ToolTipIcon from "../assets/images/info-icon.svg";
import React, { Component } from "react";
import './tool-tip2.scss'

/** @import { ToolTip2Props, ToolTip2State } from "./ToolTip2Types" */

/** 
 * reusable tool tip element based on existing tool tips on dashboard page.
 * 
 * @extends {Component<ToolTip2Props, ToolTip2State>}
 **/
class ToolTip extends Component {
    /** @type {ToolTip2State} */
    state = {
        ToolTipOpen: false,
        ToolTipTop: 0,
        ToolTipLeft: 0
    };
    /** @type {React.RefObject<HTMLDivElement>} */
    popupRef = React.createRef();

    constructor(/** @type {ToolTip2Props} */ props) {
        super(props);
    }

    /** @type {import("react").MouseEventHandler<HTMLAnchorElement>} */
    toggleToolTip = (/** @type {React.MouseEvent<HTMLAnchorElement, MouseEvent>} */ event) =>  {
        event.preventDefault();

        let button = event.currentTarget;
        let rect = button.getBoundingClientRect();
        let prect = button.offsetParent && button.offsetParent.getBoundingClientRect();

        this.setState((/** @type {ToolTip2State} */ { ToolTipOpen }) => ({
            ToolTipOpen: !ToolTipOpen,
            ToolTipTop: rect.top - (prect ? prect.top : 0) + 31,
            ToolTipLeft: rect.left - (prect ? prect.left : 0) - 16
        }));
    };

    onClickOutside = (/** @type {MouseEvent} */ event) => {
        if (
            this.state.ToolTipOpen
            && this.popupRef.current
            && getComputedStyle(this.popupRef.current).display !== 'none'
            && event.target instanceof HTMLElement
            && !this.popupRef.current.contains(event.target)
        ) {
            event.preventDefault();
            event.stopPropagation();
            this.setState({ToolTipOpen: false});
        }
    };

    componentDidMount() {
        document.body.addEventListener('click', this.onClickOutside, false);
    };

    componentWillUnmount() {
        document.body.removeEventListener('click', this.onClickOutside);
    };

    render() {
        return (
        <div className="tool-tip__icon">
                <a href="#" onClick={this.toggleToolTip}><img src={ToolTipIcon}/></a>
                {this.state.ToolTipOpen &&
                <div ref={this.popupRef}
                    className={'tooltip__popup'}
                    style={{
                        top: this.state.ToolTipTop,
                        left: this.state.ToolTipLeft,
                        // @ts-expect-error TypeScript is not aware of this property
                        "--arrow-offset": this.props.offset ? this.props.offset : "10px"
                    }}>
                    {this.props.content}
                </div>}
            </div>
        );
    }
}

export default ToolTip

export function ToolTipHover(/** @type {{ children: import('react').ReactNode; tooltipText: string; }} */ { children, tooltipText = "Tooltip Text" }) {
    const childrenWithProps = React.Children.map(children, (child) => {
        if (React.isValidElement(child)) {
            return React.cloneElement(child, {
                className: `tool-tip-trigger2 ${child.props.className || ""}`
            });
        }
        return child;
    });

    return (
        <>
            {childrenWithProps}
            <div className={`tool-tip2__hover`}>
                <p className={"not-padded"}>{tooltipText}</p>
            </div>
        </>
    );
}